import { render } from "./RunningGame.vue?vue&type=template&id=8626d2a6&scoped=true"
import script from "./RunningGame.vue?vue&type=script&lang=js"
export * from "./RunningGame.vue?vue&type=script&lang=js"

import "./RunningGame.vue?vue&type=style&index=0&id=8626d2a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8626d2a6"]])

export default __exports__